import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BrowserControlCommunicationService } from '@applications/sha-services';
import { ResponseLead } from '@quorum/models/xs-resource';

@Component({
  selector: 'crm-prospect-response-leads',
  templateUrl: './prospect-response-leads.component.html',
  styleUrls: ['./prospect-response-leads.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProspectResponseLeadsComponent implements OnInit {
  @Input() responseLeads: ResponseLead[];
  constructor(public browserControlCommunicationService: BrowserControlCommunicationService) {}

  ngOnInit() {}

  openLead(lead: ResponseLead) {
    if (!lead?.url) {
      return;
    }
    window.open(lead.url, '_blank', 'noopener,noreferrer');
  }
}
